module.exports = __webpack_public_path__ + "static/media/YF11_0.d2c701d6.jpg";